"use client";

import { CcSeoProcess } from "@/components/services/seo/CcSeoProcess";
import type { SeoPageCopy } from "@/components/services/seo/seo-page-copy";

import { AUTO_PROCESS_ILLUSTRATIONS } from "./auto-process-illustrations";

/**
 * The process section with the AI automation drawings. A client wrapper,
 * because drawing components can't be passed as props from the server view.
 */
export function CcAutoProcess({ copy }: { copy: SeoPageCopy["process"] }) {
  return <CcSeoProcess copy={copy} illustrations={AUTO_PROCESS_ILLUSTRATIONS} />;
}
